import { z } from "zod";
/**
 * The latest durable-workflow review of one channel record, so the record's own
 * panel can show it and offer the decision. The decision itself goes through the
 * shared proposal ledger (POST /api/twin/proposals/{proposalId}/decision).
 */
export const channelRecordWorkflowReviewSchema = z.object({
    proposalId: z.string().min(1),
    /** The proposal ledger's state: open, accepted, declined, deferred, superseded or expired. */
    proposalState: z.string().min(1),
    /** The workflow's continuation for this review, when it waits for the decision. */
    waitStatus: z.enum(["waiting_review", "approved", "rejected", "expired", "invalidated"]).nullable(),
    /** False when the record has changed since the review was made: the workflow re-checks it. */
    current: z.boolean(),
    /** Whether the reader is the review's recipient (or the review has none). */
    canDecide: z.boolean(),
    workflowId: z.string().min(1),
    workflowTitle: z.string(),
    createdAt: z.number().int().nonnegative(),
}).strict();
export const getChannelRecordWorkflowReviewResponseSchema = z.object({
    review: channelRecordWorkflowReviewSchema.nullable(),
}).strict();
